// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles___wrapper___2BI7O","align-bottom":"styles___align-bottom___1Ei9h","inline":"styles___inline___2aMVw","icon":"styles___icon___3d6JR"};